<div class="wrapper">
  <div class="cuerpo">
    <h1 class="tp-navandu line-navandu">REENVIAR DOCUMENTO</h1>

    @if (loading) {
      <app-spinner></app-spinner>
    } @else {
      <form name="entrar" [formGroup]="documentForm" class="formulario" autocomplete="off">
        @if (
          showSignatureChanels ||
          documentForm.controls['signatureType'].value === 2 ||
          template.templateType.name === 'File' ||
          template.templateType.name === 'SetFileAdmin' ||
          doneImageConvert === 'loading'
        ) {
          <div class="documento">
            @if (documento.documentType === 'biometric') {
              <div class="flex-row">
                <mat-form-field>
                  <mat-label>Dispositivo</mat-label>
                  <mat-select formControlName="device">
                    @for (device of devices; track device) {
                      <mat-option [value]="device.deviceName">
                        {{ device.deviceDescription }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            }
            <div class="documento sign">
              @if (doneImageConvert === 'loading') {
                <app-spinner></app-spinner>
              }
              @if (doneImageConvert === 'done') {
                <div>
                    <div class="select-state">
                      <button mat-icon-button class="refrescar" (click)="changePage('previus')" type="button">
                        <div class="tooltip3">
                          <mat-icon>chevron_left</mat-icon>
                          <span class="tooltiptext3">Anterior</span>
                        </div>
                      </button>
                      <p>Página: {{ pageImagePdf + 1 }} de {{ lengthPageImagePdf }}</p>
                      <button mat-icon-button class="refrescar" (click)="changePage('next')" type="button">
                        <div class="tooltip3">
                          <mat-icon>chevron_right</mat-icon>
                          <span class="tooltiptext3">Siguiente</span>
                        </div>
                      </button>
                    </div>
                  <div class="example-boundary" [style.backgroundImage]="'url(' + imagepdf + ')'">
                    <div
                      class="element example-box"
                      cdkDragBoundary=".example-boundary"
                      cdkDrag
                      (cdkDragEnded)="dragEnd($event, 0)"
                      id="coordinate"
                      (click)="displayContextMenu($event, 0)"
                      [cdkDragDisabled]="isDisplayContextMenu[0].locked">
                      Firma 1
                      @if (isDisplayContextMenu[0].visible) {
                        <app-context-menu
                          [ngStyle]="getRightClickMenuStyle()"
                          [contextMenuItems]="rightClickMenuItems"
                          (onContextMenuItemClick)="handleMenuItemClick($event, 0)"></app-context-menu>
                      }
                    </div>
                    @for (firmante of arraySigners; track firmante; let i = $index) {
                      <div>
                        <div
                          class="element example-box"
                          cdkDragBoundary=".example-boundary"
                          cdkDrag
                          [cdkDragFreeDragPosition]="firmante"
                          (cdkDragEnded)="dragEnd($event, i + 1)"
                          id="coordinate[{{ i }}]"
                          (click)="displayContextMenu($event, i + 1)"
                          [cdkDragDisabled]="isDisplayContextMenu[i + 1].locked">
                          Firma
                          {{ i + 2 }}
                          @if (isDisplayContextMenu[i + 1].visible) {
                            <app-context-menu
                              [ngStyle]="getRightClickMenuStyle()"
                              [contextMenuItems]="rightClickMenuItems"
                              (onContextMenuItemClick)="handleMenuItemClick($event, i + 1)"></app-context-menu>
                          }
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        }
        <div class="enviar">
          <input type="submit" class="boton" value="Reenviar" (click)="onSubmit()" [disabled]="buttonDisable" />
        </div>
        <a routerLink="/documents" class="volver"><span>Volver</span></a>
      </form>
    }
  </div>
</div>
